import { ENTRY_TYPES } from '../../models/GlossaryText';

const TAG = '#CG-GLOSSARY#';
const DELIMITER = ',';

const SERIALIZED_ENTRY_TYPES = {
  DEFINITION: '1',
  IMAGE: '2',
  EXTERNAL_LINK: '3',
};

class GlossaryTextSerializer {
  static deSerialize(data) {
    // We need to do two things:
    //  1) Get the information of each glossary entry.
    //  2) Split the text removing those entries
    const captureRegexp = new RegExp(`${TAG}(\\d)${DELIMITER}(.+?)${DELIMITER}(.+?)${TAG}`, 'g');
    const splitRegexp = new RegExp(`${TAG}\\d${DELIMITER}.+?${DELIMITER}.+?${TAG}`, 'g');

    // Capture all entries and de-serialize them.
    const glossaryEntries = [];
    let match = captureRegexp.exec(data);
    while (match) {
      let entryType = null;
      switch (match[1]) {
        case SERIALIZED_ENTRY_TYPES.DEFINITION:
          entryType = ENTRY_TYPES.DEFINITION;
          break;
        case SERIALIZED_ENTRY_TYPES.IMAGE:
          entryType = ENTRY_TYPES.IMAGE;
          break;
        case SERIALIZED_ENTRY_TYPES.EXTERNAL_LINK:
          entryType = ENTRY_TYPES.EXTERNAL_LINK;
          break;
        default:
          entryType = null;
      }
      glossaryEntries.push({
        entryType,
        value: match[2],
        text: match[3],
      });
      match = captureRegexp.exec(data);
    }

    // Split the text
    const splitText = data.split(splitRegexp);
    // Intercalate both lists into one
    const resultingList = [];
    splitText.forEach((text, index) => {
      if (text) {
        resultingList.push({
          entryType: ENTRY_TYPES.PLAIN_TEXT,
          text,
        });
      }
      if (glossaryEntries.length > index) {
        resultingList.push(glossaryEntries[index]);
      }
    });
    return {
      entries: resultingList,
    };
  }
}

export { GlossaryTextSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/GlossaryTextSerializer.js